module.exports = __webpack_public_path__ + "img/pay-per.086cab26.svg";